@if (productData) {
  <div class="pb-5">
    <form #productForm="ngForm" (ngSubmit)="saveProduct()">

      <!-- Title -->
      <app-cards-basic title="{{ 'COMMON.title' | translate }}">
        @for (lang of _languageService.supportedLangs; track lang) {
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>{{ 'COMMON.title_' + lang | translate }}</mat-label>
            <input matInput
                   required
                   [(ngModel)]="productData.translations[lang].title"
                   name="productTitle_{{ lang }}">
          </mat-form-field>
        }
      </app-cards-basic>

      <!-- Permalink -->
      <app-cards-basic title="Permalink">
        @for (lang of _languageService.supportedLangs; track lang) {
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Permalink ({{ 'COMMON.' + lang | translate }})</mat-label>
            <input matInput
                   required
                   [(ngModel)]="productData.translations[lang].slug"
                   name="slug_{{ lang }}"
                   [appSlugTransform]="productData.translations[lang].title">
          </mat-form-field>
        }
      </app-cards-basic>

      <!-- Datenverknüpfung -->
      <app-cards-basic title="Datenverknüpfung" [loading]="isLoadingPrices">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>File Url</mat-label>
          <input matInput
                 [(ngModel)]="productData.file_url"
                 name="file_url">
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Excel Sheet Name</mat-label>
          <input matInput
                 [(ngModel)]="productData.excel_sheet_name"
                 name="excel_sheet_name">
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Excel Field Product ID</mat-label>
          <input matInput
                 [(ngModel)]="productData.file_product_id"
                 name="file_product_id">
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Excel Field Category</mat-label>
          <input matInput
                 [(ngModel)]="productData.file_category"
                 name="file_category">
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Excel Field Type</mat-label>
          <input matInput
                 [(ngModel)]="productData.file_type"
                 name="file_type">
        </mat-form-field>
        <button mat-flat-button
                color="primary"
                type="button"
                (click)="importPricesFromUrl()"
                class="bp-button">
          Import from Url
        </button>
      </app-cards-basic>

      <!-- Description -->
      <app-cards-basic title="{{ 'COMMON.description' | translate }}">
        @for (lang of _languageService.supportedLangs; track lang) {
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>{{ 'COMMON.description' | translate }} ({{ 'COMMON.' + lang | translate }})</mat-label>
            <textarea matInput
                      rows="5"
                      [(ngModel)]="productData.translations[lang].description"
                      name="description_{{ lang }}"></textarea>
          </mat-form-field>
        }
      </app-cards-basic>


    </form>

    <app-cards-basic [loading]="isLoading"><!-- Actions -->
      <button mat-button
              color="primary"
              type="button"
              (click)="cancel()"
              class="bp-button">
        {{ 'ACTIONS.cancel' | translate }}
      </button>
      <button mat-flat-button
              color="primary"
              [disabled]="!productForm.valid"
              (click)="saveProduct()"
              class="bp-button">
        {{ 'ACTIONS.save' | translate }}
      </button>

    </app-cards-basic>


  </div>
}
